import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import ModalPlugin from './index'

interface VisibilityInterface {
  modal: boolean
  overlay: boolean
}

@Component
export default class Modal extends Vue {
  @Prop(String) public name!: string
  @Prop(Boolean) public preventClose!: boolean

  public modalName: string = this.name

  public visibility: VisibilityInterface = {
    modal: false,
    overlay: false,
  }

  private isOpen: boolean = false

  public setName(name: string) {
    this.modalName = name
  }

  public open(options: object) {
    this.processOptions(options)

    this.moveElementToTop()
      .then(() => {
        this.beforeOpened()
        this.isOpen = true

        this.$nextTick(() => {
          this.visibility.overlay = true
          this.visibility.modal = true
        })
      })
  }

  public close() {
    if (this.preventClose) {
      return
    }

    this.beforeClosed()
    this.visibility.overlay = false
    this.visibility.modal = false
  }

  public onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close()
    }
  }

  public created() {
    this.setName(this.name)
  }

  public beforeMount() {
    ModalPlugin.event.$on('open', (name: string, params: object) => {
      if (name === this.modalName) {
        this.open(params)
      }
    })

    ModalPlugin.event.$on('close', (name: string, params: object) => {
      if (name === this.modalName) {
        this.close()
      }
    })
  }

  private moveElementToTop() {
    return new Promise((resolve) => {
      const parent: HTMLElement = this.$el.parentNode as HTMLElement
      if (parent.tagName === 'BODY') {
        resolve()
      }

      document.body.appendChild(this.$el)
      this.$nextTick(() => {
        resolve()
      })
    })
  }

  private processOptions(options: object) {
    //
  }

  private beforeOpened() {
    window.addEventListener('keydown', this.onKeyUp)
    this.$emit('before-opened')

    document.body.classList.add('modal-open')
  }

  private beforeClosed() {
    window.removeEventListener('keydown', this.onKeyUp)
    this.$emit('before-closed')

    document.body.classList.remove('modal-open')
  }

  private afterLeave() {
    this.isOpen = false
  }
}
